import { DestinationMetadataManager } from "../destinations/DestinationMetadataManager";
import { warehouseDestinations } from "../destinations/destinations";
import { useAllSaasDestinations } from "./useAllSaasDestinations";

export const useDestinationMetadataManager = () => {
  const allSaasDestinations = useAllSaasDestinations();
  const allDestinations = { ...warehouseDestinations, ...allSaasDestinations };

  return new DestinationMetadataManager(allDestinations);
};
